document.addEventListener('DOMContentLoaded', function () {
  const modals = document.querySelectorAll('.modal');
  const modalOverlays = document.querySelectorAll('.modal-overlay');

  // 检查是否为移动设备
  function isMobile() {
    return window.innerWidth < 768;
  }

  // 设置弹窗样式
  function setModalStyle(modal) {
    if (isMobile()) {
      modal.classList.remove('desktop');
      modal.classList.add('mobile');
    } else {
      modal.classList.remove('mobile');
      modal.classList.add('desktop');
    }
  }

  // 打开弹窗
  function openModal(modal) {
    setModalStyle(modal);
    modal.classList.add('active');
    modal.querySelector('.modal-overlay').classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  // 关闭弹窗
  function closeModal(modal) {
    modal.classList.remove('active');
    modal.querySelector('.modal-overlay').classList.remove('active');
    document.body.style.overflow = '';
  }

  // 事件监听
  modals.forEach(modal => {
    const closeModalBtn = modal.querySelector('.close-btn');
    const modalOverlay = modal.querySelector('.modal-overlay');

    closeModalBtn.addEventListener('click', () => closeModal(modal));
    modalOverlay.addEventListener('click', () => closeModal(modal));

    // 按ESC键关闭弹窗
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal(modal);
      }
    });
  });

  // 初始化样式
  modals.forEach(modal => setModalStyle(modal));
});
